import FormTemplateDateField from '../presentational/FormTemplateFieldTypes/FormTemplateDateField';
import FormTemplateDescriptiveField from '../presentational/FormTemplateFieldTypes/FormTemplateDescriptiveField';
import FormTemplateOptionsField from '../presentational/FormTemplateFieldTypes/FormTemplateOptionsField';
import FormTemplateSingleLineField from '../presentational/FormTemplateFieldTypes/FormTemplateSingleLineField';

export function FormTemplateFieldTypeManager(props) {
  const { fieldValues, validateAllFields } = props;

  const returnFieldFromFieldType = () => {
    switch (fieldValues.field_type) {
      case 'single_line':
        return (
          <FormTemplateSingleLineField
            key={fieldValues.id}
            fieldValues={fieldValues}
            validateAllFields={validateAllFields}
          />
        );

      case 'descriptive':
        return (
          <FormTemplateDescriptiveField
            key={fieldValues.id}
            fieldValues={fieldValues}
            validateAllFields={validateAllFields}
          />
        );
      case 'checkbox':
        return (
          <FormTemplateOptionsField
            key={fieldValues.id}
            fieldValues={fieldValues}
            validateAllFields={validateAllFields}
          />
        );
      case 'radio':
        return (
          <FormTemplateOptionsField
            key={fieldValues.id}
            fieldValues={fieldValues}
            validateAllFields={validateAllFields}
          />
        );
      case 'dropdown':
        return (
          <FormTemplateOptionsField
            key={fieldValues.id}
            fieldValues={fieldValues}
            validateAllFields={validateAllFields}
          />
        );
      case 'date':
        return (
          <FormTemplateDateField key={fieldValues.id} fieldValues={fieldValues} validateAllFields={validateAllFields} />
        );
      default:
    }
  };

  return <>{fieldValues && returnFieldFromFieldType()}</>;
}

export default FormTemplateFieldTypeManager;
